/**
* Created by vouill on 8/18/18.
*/

<template>
  <div>
    <main-event
      v-for="event in vuexApiData.items"
      v-if="event"
      :key="event.sys.id"
      :img="getImgLink(event.fields.coverImage && event.fields.coverImage.sys.id)"
      :event="event"/>
  </div>
</template>

<script>
import MainEvent from "./main-event";
import EventTitle from "./event-title";
import { getAsset } from "../../utils/contentful";
import EventIntro from "./EventIntro";
import { hoc } from "vuex-api";

export default {
  name: "EventList",
  props: { vuexApiData: Object },
  components: { EventIntro, EventTitle, MainEvent, hoc },
  methods: {
    getImgLink: function(id) {
      return getAsset(this.vuexApiData.includes, id);
    }
  },
  data() {
    return {};
  }
};
</script>
